<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div class="dash-top-bar">
    <div class="trip-acoordion">
      <a [ngClass]="{ active: tripType == '-1' }" (click)="getTripsList('-1')" (click)="GoToAllTrips()">All Routes</a>
      <a [ngClass]="{ active: tripType == 'activeRoutes' }" (click)="getTripsList('activeRoutes')">Active Route</a>
      <a [ngClass]="{ active: tripType == 'liveTrips' }" (click)="getTripsList('liveTrips')">Live Routes</a>
      <a [ngClass]="{ active: tripType == 'completed' }" (click)="getTripsList('completed')">Completed</a>
      <a [ngClass]="{ active: tripType == 'cancelled' }" (click)="getTripsList('cancelled')">Cancelled</a>
    </div>
    <div class="dash-search-container">
      <button type="button" class="button buttonBlue fixed-btn" (click)="openCreateDRO()">
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Create
      </button>
      <button uppercase type="button" *ngIf="searchButton" (click)="openSearch()" class="button search-btn">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_button">
        <input uppercase class="search pl-2" placeholder="Driver Id / Route Id" id="searchtripID" maxlength="16" minlength="4"
          #newItem (keyup)="onInputChange(newItem)" (keyup.enter)="isInputValid && search(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_Btn" class="search_icon" (click)="search(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button *ngIf="clear_Btn" class="search_number1" (click)="resetSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="trucks">
    <div class="to_container">
      <div [class.spinner]="loading"></div>
      <div class="row m-0" *ngIf="(!driverOrdersList || !driverOrdersList.length) && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
    <div class="row m-0" *ngIf="driverOrdersList && driverOrdersList.length > 0 && !loading">
      <div class="col-12 col-md-6 col-lg-4 mb-3 px-1" *ngFor="let item of driverOrdersList; let i = index">
        <div class="truckscol">
          <div class="card">
            <div class="trips">
              <p class="ticket" matTooltip="View Route Details" matTooltipPosition="above" (click)="viewDriver(item)">
                {{ item.driver_route_unique_id }}
                <span class="user-type-badge customer-badge" *ngIf="item?.trip_details?.[0]?.userInfo?.user_type === 'customer'" style="font-size: 11px; margin-left: 6px; padding: 2px 6px; border-radius: 4px; background-color: #e3f2fd; color: #0d47a1; font-weight: bold; border: 1px solid #90caf9; display: inline-block; vertical-align: middle;">Retail</span>
                <span class="user-type-badge corporate-badge" *ngIf="item?.trip_details?.[0]?.userInfo?.user_type === 'corporate'" style="font-size: 11px; margin-left: 6px; padding: 2px 6px; border-radius: 4px; background-color: #efebe9; color: #4e342e; font-weight: bold; border: 1px solid #bcaaa4; display: inline-block; vertical-align: middle;">Corporate</span>
              </p>
              <img src="../../../assets/img/edit.svg" *ngIf="item?.driver_details?.[0]?.driver_trip_status == 'waitForTrip' && item?.driver_trip_route_status == 'new_route'" style="width: 18px; cursor: pointer; opacity: 0.7;" (click)="editDRO(item)" alt="Edit" title="Edit" onmouseover="this.style.opacity='1'" onmouseout="this.style.opacity='0.7'">
            </div>
            <div class="payment-container">
              <div class="location-payment">
                <img [src]="item.stops && item.stops.length > 0
                          ? '../../../assets/img/location-payment-stop.svg'
                          : '../../../assets/img/location-payment.svg'"
                  [matTooltip]="item.stops && item.stops.length > 0 ? ('Stops: ' + item.stops.length) : ''"
                  [matTooltipDisabled]="!(item.stops && item.stops.length > 0)" matTooltipPosition="right" alt="" />
                <span class="places">
                  <span>{{ item?.fromLocation?.from_city_name }}</span>
                  <span>{{ item?.toLocation?.to_city_name }}</span>
                </span>
              </div>
              <div class="payment">
                <!-- Customer Fare -->
                <div class="amount" *ngIf="item?.trip_details?.[0]?.userInfo?.user_type === 'customer'">
                  ₹ {{ item.total_fare | number : '1.2-2' }}
                </div>

                <!-- Corporate Fare -->
                <div class="amount" *ngIf="item?.trip_details?.[0]?.userInfo?.user_type === 'corporate'">
                  ₹
                  {{
                  item.bidDetails?.[0]?.trip_status === 'pending' ||
                  item.bidDetails?.[0]?.trip_status === 'trip_not_booked'
                  ? (0 | number : '1.2-2')
                  : (
                  item.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
                  ? (item.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                  (item.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                  : item.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
                  ? (item.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                  (item.tripInfo?.workOrderOtherDetails?.unloading_point || item.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                  : item.trip_payment_info?.[0]?.price_details?.amount_paid ||
                  item.total_fare ||
                  0
                  ) | number : '1.2-2'
                  }}
                </div>
                <div class="amount-tax">(After deductions - Taxes & Fee)</div>
              </div>
            </div>
            <p class="truck-date">
              Actual Amount :
              <!-- For Customer -->
              <span *ngIf="item?.trip_details?.[0]?.userInfo?.user_type === 'customer'">
                ₹ {{ item.route_fare | number : '1.2-2' }}
              </span>

              <!-- For Corporate -->
              <span *ngIf="item?.trip_details?.[0]?.userInfo?.user_type === 'corporate'">
                ₹
                {{
                item.bidDetails?.[0]?.trip_status === 'pending' ||
                item.bidDetails?.[0]?.trip_status === 'trip_not_booked'
                ? (0 | number : '1.2-2')
                : (
                item.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
                ? (item.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                (item.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                : item.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
                ? (item.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                (item.tripInfo?.workOrderOtherDetails?.unloading_point || item.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                : item.trip_payment_info?.[0]?.price_details?.amount_paid ||
                item.price ||
                0
                ) | number : '1.2-2'
                }}
              </span>
            </p>
            <p class="truck-date">
              Truck No: {{ item.truck_details?.[0]?.truck_number }}
            </p>
            <p class="truck-detail">
              {{ item.truck_type?.[0]?.truck_weight }},
              {{ item.truck_type?.[0]?.truck_feet }},
              {{ item.truck_category?.[0]?.truck_category_name }}
            </p>
            <p class="truck-date" *ngIf="item?.trip_details?.length">
              Trip ID: {{ item.trip_details[0]?.trip_id }}
            </p>
            <p class="truck-date">
              Driver Contact: {{ item.driver_details?.[0]?.mobile }}
            </p>
            <p class="truck-date" *ngIf="item?.trip_details?.[0]?.userInfo?.user_type == 'corporate'">
              Corporate Contact: {{ item.trip_details[0]?.userInfo?.mobile }}
            </p>
            <p class="truck-date" *ngIf="item?.trip_details?.[0]?.userInfo?.user_type == 'customer'">
              Customer Contact: {{ item.trip_details[0]?.userInfo?.mobile }}
            </p>
          </div>

          <!-- Payment Amount -->
          <!-- Paid/Remaining/Balance for Customer and Corporate Trips -->
          <div class="col-footer1" *ngIf="
              (item?.driver_details?.[0]?.driver_trip_status === 'trip_booked' || item?.trip_details?.[0]?.trip_status == 'completed') &&
              (item?.trip_details?.[0]?.userInfo?.user_type === 'customer' || item?.trip_details?.[0]?.userInfo?.user_type === 'corporate') &&
              getTransporterTotalPaid(item.truckownerPaymentInfo) === 0
            ">
            <div class="side2">
              <h3>Remaining Balance:</h3>
              <p>₹ {{ getTransporterFare(item) | number : '1.2-2' }} /-</p>
            </div>
          </div>

          <div class="col-footer" *ngIf="
              (item?.driver_details?.[0]?.driver_trip_status === 'trip_booked' || item?.trip_details?.[0]?.trip_status == 'completed') &&
              (item?.trip_details?.[0]?.userInfo?.user_type === 'customer' || item?.trip_details?.[0]?.userInfo?.user_type === 'corporate') &&
              getTransporterTotalPaid(item.truckownerPaymentInfo) > 0 &&
              getTransporterTotalPaid(item.truckownerPaymentInfo) < getTransporterFare(item)
            ">
            <div class="side1">
              <h3>Paid:</h3>
              <p>
                ₹ {{ getTransporterTotalPaid(item.truckownerPaymentInfo) | number : '1.2-2' }} /-
              </p>
            </div>
            <div class="side1">
              <h3>Balance:</h3>
              <p>
                ₹ {{
                getTransporterFare(item) - getTransporterTotalPaid(item.truckownerPaymentInfo) | number : '1.2-2'
                }} /-
              </p>
            </div>
          </div>

          <div class="col-footer1" *ngIf="
              (item?.driver_details?.[0]?.driver_trip_status === 'trip_booked' || item?.trip_details?.[0]?.trip_status == 'completed') &&
              (item?.trip_details?.[0]?.userInfo?.user_type === 'customer' || item?.trip_details?.[0]?.userInfo?.user_type === 'corporate') &&
              getTransporterTotalPaid(item.truckownerPaymentInfo) >= getTransporterFare(item) &&
              getTransporterFare(item) > 0
            ">
            <div class="side2">
              <h3>Total Paid:</h3>
              <p>₹ {{ getTransporterFare(item) | number : '1.2-2' }} /-</p>
            </div>
          </div>

          <!--Trip Status -->
          <div class="waitForTrip" *ngIf="
              item?.driver_details?.[0]?.driver_trip_status == 'waitForTrip' &&
              item?.driver_trip_route_status == 'new_route'
            ">
            <span class="notification text-center">Waiting for Booking</span>
          </div>

          <div class="cancel_route" *ngIf="
              item?.driver_trip_route_status == 'cancel_route' ||
              item.trip_details?.trip_status == 'cancelled'
            ">
            <span class="notification text-center">Cancelled Route</span>
          </div>
          <div class="trip_booked" *ngIf="
              item?.trip_details?.[0]?.trip_status == 'quoteBooked' &&
              item.driver_trip_route_status == 'new_route'
            ">
            <span class="notification text-center">Quote Booked</span>
          </div>
          <div class="trip_booked" *ngIf="
              item?.trip_details?.[0]?.trip_status == 'completed' &&
              item.driver_trip_route_status == 'old_route'
            ">
            <span class="notification text-center">Trip Completed</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>

  <div *ngIf="last_page && last_page > 1" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2" (click)="pagination('-1')">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <button class="btn" [disabled]="fetch_page == 1">
      <img src="../../../assets/img/pagination-left.svg" (click)="pagination('first')" alt="" class="btn--icon" />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button class="btn" [disabled]="last_page == fetch_page">
      <img src="../../../assets/img/pagination-right.svg" (click)="pagination('last')" alt="" class="btn--icon" />
    </button>
    <button class="btn" [disabled]="last_page == fetch_page">
      <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2" (click)="pagination('1')">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>
